import React from 'react';

import { formatDate } from 'src/utils/Date';

import styles from './TargetDetailPeriod.scss';
import { useTranslation } from 'react-i18next';

const TargetDetailPeriod = ({ attendanceStartDate, attendanceEndDate, paymentDate }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.targetPeriod}>
      <div>
        {t('components.BonusFormModal.Subjected_period')} {formatDate(attendanceStartDate)} ~ {formatDate(attendanceEndDate)}
      </div>
      <div className={styles.paymentDate}>{t('components.BonusFormModal.Payment_date')} {formatDate(paymentDate)}</div>
    </div>
  );
};

export default TargetDetailPeriod;
